export type Intent =
  | "reminder"
  | "update"
  | "engagement"
  | "action"
  | "information";
export type Tone = "supportive" | "informative" | "friendly" | "formal";

export interface Template {
  intent: Intent;
  tone: Tone;
  message: string;
}

export const templates: Template[] = [
  {
    intent: "reminder",
    tone: "supportive",
    message:
      "A reminder that your membership benefits are available at [venue]. View your digital card.",
  },
  {
    intent: "reminder",
    tone: "informative",
    message:
      "A reminder that your loyalty programme benefits are ready to use. View your digital card.",
  },
  {
    intent: "reminder",
    tone: "friendly",
    message:
      "Just a reminder that your membership benefits are available at [venue]. Check your digital card.",
  },
  {
    intent: "reminder",
    tone: "formal",
    message:
      "This is a reminder that membership benefits are available at [venue]. View your digital card.",
  },
  {
    intent: "update",
    tone: "supportive",
    message:
      "We've updated the benefits available at [venue] to serve you better. View your digital card.",
  },
  {
    intent: "update",
    tone: "informative",
    message:
      "There are changes to your membership at [venue]. View your digital card for details.",
  },
  {
    intent: "update",
    tone: "friendly",
    message:
      "[Venue] has updated your membership information. Check your digital card for details.",
  },
  {
    intent: "update",
    tone: "formal",
    message:
      "An update regarding your [venue] membership is now available. View your digital card.",
  },
  {
    intent: "engagement",
    tone: "supportive",
    message:
      "Your loyalty programme benefits are available at [venue]. View your digital card.",
  },
  {
    intent: "engagement",
    tone: "informative",
    message:
      "As a member, you have access to a range of benefits at [venue]. View your digital card.",
  },
  {
    intent: "engagement",
    tone: "friendly",
    message:
      "Being a member at [venue] has its perks! Check your digital card to see what's available.",
  },
  {
    intent: "engagement",
    tone: "formal",
    message:
      "Your membership entitlements at [venue] are available for your reference. View your digital card.",
  },
  {
    intent: "action",
    tone: "supportive",
    message:
      "Your [venue] membership has a notification for you. View your digital card for details.",
  },
  {
    intent: "action",
    tone: "informative",
    message:
      "A notification regarding your [venue] membership is available. View your digital card.",
  },
  {
    intent: "action",
    tone: "friendly",
    message:
      "You have a membership notification from [venue]. Check your digital card for details.",
  },
  {
    intent: "action",
    tone: "formal",
    message:
      "A membership notification from [venue] is available. View your digital card for details.",
  },
  {
    intent: "information",
    tone: "supportive",
    message:
      "Good news! Your [venue] membership is active and your loyalty benefits are ready to use. View your digital card.",
  },
  {
    intent: "information",
    tone: "informative",
    message:
      "Your membership at [venue] is currently active. Venue information is available on your digital card.",
  },
  {
    intent: "information",
    tone: "friendly",
    message:
      "Your membership at [venue] is active. Check your digital card for venue information and benefits.",
  },
  {
    intent: "information",
    tone: "formal",
    message:
      "Your membership at [venue] is currently active. Venue information and benefits are available on your digital card.",
  },
];

export const toneLabels: Record<Tone, string> = {
  supportive: "Supportive",
  informative: "Informative",
  friendly: "Friendly",
  formal: "Formal",
};
